import React from 'react'

const PrintButtonCell = (props) => {

    return (
        <div id={props.cellContent} className='row__cell'>
            {props.cellContent ?
                <div onClick={e => props.cellData.showModal(e.target)}
                     style={{
                         width: '30px',
                         background: 'blue',
                         borderRadius: '30px',
                         height: '30px',
                         cursor: "pointer"
                     }}/> : ''}
        </div>)
}
export default PrintButtonCell
